export default __webpack_public_path__ + "static/media/1(19)_tn.6d110f0b.jpg";